import React from "react";
import { Row, Col } from "antd";
import CardInbound from "./card_inbound_client";
import CardOutbound from "./card_outbound_client";
import CardTransaction from "./card_transaction_client";
import CardPayment from "./card_payment_client";

const SummaryClientDashboard = () => {
  return (
    <Row gutter={16}>
      <Col span={6}>
        <CardInbound />
      </Col>
      <Col span={6}>
        <CardOutbound />
      </Col>
      <Col span={6}>
        <CardTransaction />
      </Col>
      <Col span={6}>
        <CardPayment />
      </Col>
    </Row>
  );
};

export default SummaryClientDashboard;
